import React from "react";
import EntityTable from "../EntityTable";
import {
  anchorConnectionColumnId,
  renderRowUpdateAction,
} from "../../common/TableUtils";
import { ConnectionFormDataController } from "../../controllers/formController";
import { Person } from "../../types/person";
import { MRT_ColumnDef } from "material-react-table";
import { PlaceOfPerson } from "../../types/placeOfPerson";
import {
  placeOfPersonColumns,
  placeOfPersonFilterSpec,
} from "../../common/entities/PlaceOfPersonColumns";
import usePlaceOfPersonQuery from "../../hooks/query/connections/usePlaceOfPersonQuery";
import { Place } from "../../types/place";
import PlaceOfPersonDialog from "../modals/PlaceOfPerson/PlaceOfPersonDialog";
import useServerFilters from "../../hooks/useServerFilters";

interface PlaceOfPersonConnectionTableProps {
  columns?: MRT_ColumnDef<PlaceOfPerson, any>[];
  filters?: Partial<PlaceOfPerson>;
  controller: ConnectionFormDataController<PlaceOfPerson, Person, Place>;
}

const PlaceOfPersonTable: React.FC<PlaceOfPersonConnectionTableProps> = ({
  columns = placeOfPersonColumns,
  controller,
  filters = {},
}) => {
  const {
    serverFilters,
    entityTableFilterProps,
    pagination,
    setPagination,
  } = useServerFilters(filters, placeOfPersonFilterSpec);
  const { useFetchConnectedEdges } = usePlaceOfPersonQuery();
  const { anchorEntity, direction, openEditDialog } = controller;
  const { data, isLoading, errorMessage } = useFetchConnectedEdges(
    anchorEntity._id,
    direction,
    {
      bodyParams: serverFilters,
      externalPagination: pagination,
      externalSetPagination: setPagination,
    }
  );

  const renderRowActions = renderRowUpdateAction<PlaceOfPerson>((row) =>
    openEditDialog(row._key)
  );

  return (
    <>
      <EntityTable
        loading={isLoading}
        error={errorMessage}
        columns={columns}
        hiddenColumnIds={[anchorConnectionColumnId(direction)]}
        renderRowActions={renderRowActions}
        enableRowActions
        data={data?.data || []}
        pagination={pagination}
        manualPagination={true}
        onPaginationChange={setPagination}
        totalRowCount={data?.total || 0}
        manualFiltering
      {...entityTableFilterProps}
      />
      <PlaceOfPersonDialog controller={controller} />
    </>
  );
};

export default PlaceOfPersonTable;
